// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__Sxoyc","choiceBoxes":"toolbarselects_choiceBoxes__3HC8O","simpleField":"toolbarselects_simpleField__2uhB_"};